import { combineReducers } from 'redux';
import eventSelector from '../EventSelector/Modal/reducer';
import promotion from '../Promotion/Modal/reducer';

export default combineReducers({
  eventSelector,
  promotion,
});
